// @flow

import React from 'react';
import { format } from 'date-fns';
import { Label, FormGroup, InputGroup } from 'reactstrap';
import { ErrorMessage, connect as formikConnect, formikBag } from 'formik';

import { DateRangePickerInput } from '@honeyguide/components';
import '@honeyguide/components/dist/components/DateRangePicker/Calendar.css';

const formatDate = (formatString: string) => (date: Object) =>
  format(date, formatString);

const formatForApi = formatDate('YYYY-MM-DD');

const TODAY = new Date();

const DatePicker = ({ formik }: { formik: formikBag }) => {
  const { values, setFieldValue } = formik;
  const { departureDate, arrivalDate, tripType } = values;
  const isRoundTrip = tripType === 'R';

  const setDepartureDate = date =>
    setFieldValue('departureDate', formatForApi(date));
  const setArrivalDate = date =>
    setFieldValue('arrivalDate', formatForApi(date));

  return isRoundTrip ? (
    <LabelWithErrorWrapper
      title="Departure - Arrival Date"
      name="departureDate"
    >
      <DateRangePickerInput
        initialStartDate={departureDate}
        initialEndDate={arrivalDate}
        onApply={(startDate, endDate) => {
          setDepartureDate(startDate);
          setArrivalDate(endDate);
        }}
        inputProps={{
          placeholder: 'Select Departure - Arrival Date',
          name: 'departureDate',
        }}
        initialShowStartDateText="Select your departure date"
        initialShowEndDateText="Select your arrival date"
        showNumNights={false}
      />
    </LabelWithErrorWrapper>
  ) : (
    <LabelWithErrorWrapper title="Departure Date" name="departureDate">
      <DateRangePickerInput
        key="singledate"
        minDate={TODAY}
        initialStartDate={departureDate}
        inputProps={{
          placeholder: 'Select Departure Date',
        }}
        onApply={setDepartureDate}
        boostrapDateRangePickerProps={{
          singleDatePicker: true,
        }}
      />
    </LabelWithErrorWrapper>
  );
};

function LabelWithErrorWrapper(props) {
  const { title, children, name } = props;

  return (
    <FormGroup>
      <Label className="title">{title}:</Label>
      <InputGroup>{children}</InputGroup>{' '}
      <ErrorMessage name={name}>
        {(error: string) => <p className="error">{error}</p>}
      </ErrorMessage>
    </FormGroup>
  );
}

export default formikConnect(DatePicker);



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/FormElements/DatePicker.js